import React from "react";
import { Formik, Form } from "formik";
import { TextField } from "./TextField";
import * as Yup from "yup";
import YupPassword from "yup-password";
YupPassword(Yup);

export const Signup = () => {
  const validate = Yup.object({
    username: Yup.string()
      .email("Email is invalid")
      .required("Email is required"),
    companyName: Yup.string(),
    password: Yup.string()
      .required("Required")
      .min(
        8,
        "password must contain 8 or more characters with at least one of each: uppercase, lowercase, number and special"
      )
      .minLowercase(1, "password must contain at least 1 lower case letter")
      .minUppercase(1, "password must contain at least 1 upper case letter")
      .minNumbers(1, "password must contain at least 1 number"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password"), null], "Passwords must match")
      .required("Required"),
    reasonForUse: Yup.string().required("Required"),
  });
  const [checked, setChecked] = React.useState(false);
  const [isError, setIsError] = React.useState(false);
  const [statusMessage, setStatusMessage] = React.useState("");

  async function register(values) {
    const result = await fetch("./api/FtpAccount", {
      method: "POST",
      headers: { "Content-type": "application/json" },
      body: JSON.stringify(values),
    });
    setIsError(!result.ok);
    const data = await result.text();
    return data;
  }

  return (
    <Formik
      initialValues={{
        username: "",
        companyName: "",
        password: "",
        confirmPassword: "",
        reasonForUse: "",
      }}
      validationSchema={validate}
      onSubmit={(values, {resetForm}) => {
        setStatusMessage("");
        resetForm();
        setIsError(false);
        register(values)
          .then((result) => {
            setStatusMessage(result);
          })
          .catch((_) => {
            setIsError(true);
            setStatusMessage(
              "Unable to process request, please contact Traveline directly."
            );
          });
      }}
    >
      <div>
        <h1 className="my-5 font-weight-bold .display-4">
          Register for TNDS FTP access.
        </h1>
        <Form>
          <TextField label="Email" name="username" type="email" />
          <TextField label="Company Name" name="companyName" type="text" />
          <TextField label="Password" name="password" type="password" />
          <TextField
            label="Confirm Password"
            name="confirmPassword"
            type="password"
          />
          <TextField label="Reason For Use" name="reasonForUse" type="text" />
          <label className="mt-3">
            <input
              type="checkbox"
              checked={checked}
              onChange={() => setChecked(!checked)}
            />{" "}
            By submitting this form I agree to the
            <a
              href="https://www.nationalarchives.gov.uk/doc/open-government-licence/version/3/"
              target="_blank"
            >
              {" "}
              Open Government Licence{" "}
            </a>
            for my use of the TNDS and you are accepting our privacy policy,
            which describes how we use your personal data.
          </label>
          <button
            className="btn btn-dark mt-2 m-1"
            type="submit"
            disabled={!checked}
          >
            Register
          </button>
          <button className="btn btn-danger mt-2 m-1" type="reset">
            Reset
          </button>
        </Form>
        <div className="mt-1" style={{ color: isError ? "red" : "green" }}>
          {statusMessage}
        </div>
      </div>
    </Formik>
  );
};
